import { type Url } from '@global-types/url.ts';

export const OBFUSCATE_ATTRIBUTE_NAME: string = 'obfsc';

export const obfuscateHref = (url: Url): string => {
  const encodedUrl = btoa(url);
  return `data-${OBFUSCATE_ATTRIBUTE_NAME}-href="${encodedUrl}"`;
};
